import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { ArrowRightLeft } from 'lucide-react';
import { formatCurrency } from './helpers';

export const MoveLaborDialog = ({
  open, onOpenChange, selectedCount, selectedAmount,
  jobs, targetJobId, setTargetJobId, reason, setReason,
  onConfirm, isMoving
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className='max-w-md'>
      <DialogHeader>
        <DialogTitle className='flex items-center gap-2'>
          <ArrowRightLeft className='w-5 h-5' />
          Move Labor Entries
        </DialogTitle>
        <DialogDescription>
          Move {selectedCount} selected labor entries to a different job.
          Total amount: {formatCurrency(selectedAmount)}
        </DialogDescription>
      </DialogHeader>

      <div className='space-y-4 py-4'>
        <div className='space-y-2'>
          <Label>Target Job</Label>
          <Select value={targetJobId} onValueChange={setTargetJobId}>
            <SelectTrigger data-testid="move-target-job-select">
              <SelectValue placeholder="Select target job..." />
            </SelectTrigger>
            <SelectContent>
              {jobs.map(job => (
                <SelectItem key={job.id} value={job.id}>
                  {job.jobNumber} - {job.description?.substring(0, 30)}...
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className='space-y-2'>
          <Label>Reason for Move</Label>
          <RadioGroup value={reason} onValueChange={setReason} className='space-y-2'>
            <div className='flex items-start space-x-3 p-3 border rounded-sm hover:bg-slate-50'>
              <RadioGroupItem value='cross_charge' id='cross_charge' />
              <div className='flex-1'>
                <Label htmlFor='cross_charge' className='font-medium cursor-pointer'>
                  Cross Charge (PO Over-Utilized)
                </Label>
                <p className='text-sm text-slate-500'>
                  Creates a cross-charge record for audit trail. Use when moving charges because the original job's PO is over budget.
                </p>
              </div>
            </div>
            <div className='flex items-start space-x-3 p-3 border rounded-sm hover:bg-slate-50'>
              <RadioGroupItem value='correction' id='correction' />
              <div className='flex-1'>
                <Label htmlFor='correction' className='font-medium cursor-pointer'>
                  Correction (Wrong Job)
                </Label>
                <p className='text-sm text-slate-500'>
                  Simple correction without cross-charge. Use when labor was accidentally entered on the wrong job.
                </p>
              </div>
            </div>
          </RadioGroup>
        </div>
      </div>

      <DialogFooter>
        <Button variant='outline' onClick={() => onOpenChange(false)} className='rounded-sm'>Cancel</Button>
        <Button onClick={onConfirm} disabled={!targetJobId || isMoving}
          className='bg-[#1A3668] hover:bg-[#142A52] rounded-sm' data-testid="confirm-move-labor">
          {isMoving ? 'Moving...' : `Move ${selectedCount} Entries`}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
